import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, IconButton } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import StaticColumnTable from "../../../../Components/Common/StaticColumnTable";
import { Add, Delete } from "@mui/icons-material";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI305_6 = ({hide}) => {
    const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
const inputData = [
    {
      fieldName: "odsProduction",
      title:
        "a. Total Ozone Depleting Substances from activity in metric tons of CFC-11 eq.",
      type: "array",
      fields: [
        {
          fieldName: "processOfCompany",
          title: "Process of Company",
          type: "text",
          placeholder: "Enter Text",
          width: "19%",
        },
        {
          fieldName: "odsProduction",
          title: "ODS produced",
          type: "number",
          placeholder: "Enter Number",
          width: "16%",
        },
        {
          fieldName: "odsDestroyed",
          title: "ODS destroyed by approved Technologies",
          type: "number",
          width: "20%",
          placeholder: "Enter Number",
        },
        {
          fieldName: "odsEntirelyUsed",
          title:
            "ODS entirely used as feedstock in the manufacture of other chemicals",
          type: "number",
          width: "20%",
          placeholder: "Enter Number",
        },
        {
          fieldName: "productionOds",
          title: "Production of ODS",
          type: "number",
          width: "16%",
          placeholder: 0,
        },
      ],
    },
  ];

  const defaultSegments = ["Production", "Imports", "Exports"];

  const questionData = [
    {
      fieldName: "specifyEmission",
      title: "c. Specify the emission factors to be taken for calculation",
      type: "text",
    },
    {
      fieldName: "standardsMethodologies",
      title:
        "d. Which are the standards, methodologies, assumptions, and/or calculation tools used.",
      type: "text",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [rowIndex, setRowIndex] = useState();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.ozoneDepleting;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddRow = () => {
    setFormData((prev) => ({
      ...prev,
      substancesIncluded: [...prev.substancesIncluded, ""],
    }));
  };

  const handleRemoveRow = (index) => {
    setRowIndex(index); // Set the index of the row to be removed
    const isRowEmpty = formData?.substancesIncluded?.[index] === "";
    if (isRowEmpty) {
      // If the row is empty, immediately remove it
      setFormData((prev) => ({
        ...prev,
        substancesIncluded: prev.substancesIncluded.filter(
          (_, i) => i !== index
        ), // Remove row at rowIndex
      }));
      setErrors({});
    } else {
      // Otherwise, show the dialog for confirmation
      setOpenDialog(true);
    }
  };

  const cancelRemoveRow = () => {
    setOpenDialog(false); // Close the confirmation dialog
  };

  const confirmRemoveRow = () => {
    // Remove the row at rowIndex
    setFormData((prev) => ({
      ...prev,
      substancesIncluded: prev.substancesIncluded.filter(
        (_, i) => i !== rowIndex
      ), // Remove row at rowIndex
    }));
    setErrors({});
    setRowIndex(); // Clear the rowIndex state
    setOpenDialog(false); // Close the confirmation dialog
  };

  useEffect(() => {
    setFormData({
      substancesIncluded: data?.substancesIncluded || [""],
      specifyEmission: data?.specifyEmission || "",
      standardsMethodologies: data?.standardsMethodologies || "",
    });
  }, [data]);

  // If an index is provided, we're updating a specific element in the substancesIncluded object
  const handleChange = (fieldName, value, type, index) => {
    // Validate the value if it's a number
    if (type === "number" && !validateNumber(value)) return;

    if (index !== undefined) {
      // Update specific element in the substancesIncluded array
      setFormData((prev) => ({
        ...prev,
        substancesIncluded: prev?.substancesIncluded.map(
          (item, i) => (i === index ? value : item) // Update value at specific index
        ),
      }));
    } else {
      // Update regular field
      setFormData((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    }
  };

  const validate = () => {
    const length = formData?.substancesIncluded?.length;
    const value = formData?.substancesIncluded?.[length - 1];
    if (length > 1) {
      if (value === "")
        setErrors((prev) => ({ ...prev, value: "This field is Required" }));

      console.log(errors, "v1");
      if (value === "") return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validate()) return;
      let transformedData2 = {
        ozoneDepleting: { ...restructureData(tables), ...formData },
        type: "GRI300",
        submitted305_6: true,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/305-7/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/305-7/${id}`);
    }
  };


  const renderContent = ({hide}) => (
     <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      {!hide && <p className={styles.section_heading}>305 : Emissions</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "1rem" }}>
        305-6 : Emissions of ozone-depleting substances (ODS)
      </p>
      <StaticColumnTable
        {...{
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments,
          parameter: "processOfCompany",
          rowTotalField: "productionOds",
          fieldName: "odsProduction",
          disabled: disabled,
        }}
      />
      <p className={styles.ques_heading} style={{ marginBottom: hide ? "-1rem" : "1rem" }}>
        b. What are the substances included in the calculations?
      </p>
      {(formData?.substancesIncluded?.length > 0
        ? formData?.substancesIncluded
        : [""]
      ).map((el, i) => (
        <Box key={i} sx={{ mt: i !== 0 && 3, display: "flex" }}>
          <Box sx={{ ml: 2.5, width: "100%" }}>
            <InputField
              placeholder="Enter Text"
              fieldName="substancesIncluded"
              value={el}
              handleChange={(e) => {
                const updatedValues = [
                  ...(formData?.substancesIncluded || [""]),
                ];
                updatedValues[i] = e.target.value;
                handleChange("substancesIncluded", updatedValues, "array");
              }}
              mt="-5px"
              errors={Boolean(errors["substancesIncluded"])}
              disabled={disabled}
            />
            {i === (formData?.substancesIncluded?.length || 1) - 1 &&
              errors?.value && (
                <p
                  color="error"
                  variant="caption"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                  }}
                >
                  {errors?.value}
                </p>
              )}
          </Box>
          {!hide &&
                    <IconButton
            disabled={
              (formData?.substancesIncluded?.length || 1) === 1 || disabled
            }
            onClick={() => handleRemoveRow(i)}
            color="error"
            sx={{ mt: "-1rem" }}
          >
            <Delete />
          </IconButton>
}
        </Box>
      ))}
               {!hide &&
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: hide ? 0 : 2 }}>
        <Button
          endIcon={<Add />}
          disabled={
            disabled ||
            formData?.substancesIncluded?.[
              formData?.substancesIncluded?.length - 1
            ] === ""
          }
          onClick={() => handleAddRow()}
          sx={{
            // marginTop: "1rem",
            color: "#1C486B",
            width: "7rem",
            borderColor: "#1C486B",
          }}
          variant="outlined"
        >
          Add
        </Button>
      </Box>
}
      {questionData.map((el) => (
        <Box key={el.fieldName} sx={{ mt: hide ? 0 : 2 }}>
          <p className={styles.ques_heading}>{el?.title}</p>
          <Box sx={{ ml: 2.5 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={(e) => {
                handleChange(el?.fieldName, e.target.value, el?.type);
              }}
              mt="-5px"
              errors={Boolean(errors[el.fieldName])}
              disabled={disabled}
            />
          </Box>
        </Box>
      ))}
     
    </>
  )
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI305_6;
